const calculateVO2Max = (distanceKm, durationSeconds) => {
  const distance = parseFloat(distanceKm);
  const duration = parseFloat(durationSeconds);

  if (!isFinite(distance) || !isFinite(duration) || distance <= 0 || duration <= 0) {
    console.warn('⚠️ [calculateVO2maxSwimming] Valores inválidos:', { distanceKm, durationSeconds });
    return null;
  }

  const minutes = duration / 60;
  const distancePer12min = (distance / minutes) * 12; // km en 12 min
  const meters = distancePer12min * 1000;

  const vo2max = (meters - 504.9) / 44.73;

  return parseFloat(vo2max.toFixed(2));
};

// ✅ Exporta ambos para mantener compatibilidad
module.exports = {
  calculateVO2Max,
  calculateSwimmingVO2max: calculateVO2Max,
};
